export default "__VITE_ASSET__RYbKS9xB__"